import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../environments/environment';
// import { tokenNotExpired } from 'angular2-jwt';
import Auth0Lock from 'auth0-lock';
import {MatSnackBar} from '@angular/material';
import {ApiService} from './api.service';
import {User} from './user';

@Injectable()
export class AuthService {
  private user: User = <User>{};
  private authUser: any;
  auth0Options = {
    theme: {
      logo: 'assets/fav-icon.png',
      primaryColor: '#DFA612'
    },
    auth: {
      redirectUrl: environment.auth0.callbackURL,
      responseType: 'token id_token',
      audience: `https://${environment.auth0.domain}/userinfo`,
      params: {
        scope: 'openid profile email'
      }
    },
    autoclose: true,
    oidcConformant: true,
  };

  lock = new Auth0Lock(
    environment.auth0.clientId,
    environment.auth0.domain,
    this.auth0Options
  );

  constructor(private router: Router, private messageSnackBar: MatSnackBar, private api: ApiService) {
    this.lock.on('authenticated', (authResult: any) => {
      this.lock.getUserInfo(authResult.accessToken, (error, profile) => {
        if (error) {
          throw new Error();
        }

        this.setSession(authResult);

        // get the detailed information about this user - we need a better picture of this user
        this.api.getUserByToken(authResult.idToken).subscribe(
          res => {
            this.authUser = res;
            if (!this.authUser.picture_large) {
              this.user.picture = this.authUser.picture;
            } else {
              this.user.picture = this.authUser.picture_large;
            }

            // save some of the user's personal data to local storage
            localStorage.setItem('token', authResult.idToken);
            this.user.token = authResult.idToken;
            this.user.profile = JSON.stringify(profile);
            this.user.name = profile.name;
            this.user.email = profile.email;

            this.api.getUserData(this.user.name, this.user.email, this.user.picture).subscribe(
              res => {
                this.user.user_id = res[0].user_id;
                this.user.role = res[0].role;

                // save user's data locally
                localStorage.setItem('user', JSON.stringify(this.user));

                // notify the user
                this.messageSnackBar.open('Login successful!', 'OK', {
                  duration: 3000
                });
              });
          }
        );

        // this.router.navigate(['/']);
      });
    });

    this.lock.on('authorization_error', error => {
      // console.log('something went wrong', error);
      if (error.error === 'access_denied') {
        this.messageSnackBar.open('Access to your public profile and email is required to engage with uploading and transcribing of postcards.', 'OK', {
          duration: 6000,
        });
      }
    });
  }

  login() {
    this.lock.show();
  }

  logout() {
    localStorage.clear();
    this.router.navigate(['/']);
  }

  isAuthenticated() {
    // Check whether the current time is past the access token's expiry time
    const expiresAt = JSON.parse(localStorage.getItem('expires_at'));
    return new Date().getTime() < expiresAt;
  }

  private setSession(authResult): void {
    // Set the time that the access token will expire at
    const expiresAt = JSON.stringify((authResult.expiresIn * 1000) + new Date().getTime());
    localStorage.setItem('expires_at', expiresAt);
  }
}
// export class AuthService {

  // public redirectUrl: string;
  // auth0 = new auth0.WebAuth({
  //   clientID: AUTH_CONFIG.clientID,
  //   domain: AUTH_CONFIG.domain,
  //   responseType: 'token id_token',
  //   audience: `https://${AUTH_CONFIG.domain}/userinfo`,
  //   redirectUri: 'http://localhost:4200/profile',
  //   scope: 'openid'
  // });
  // private user: any;
  // private picture: string;

  // constructor(public router: Router, private api: ApiService) {
  // }
  //
  // public login(): void {
  //   this.auth0.authorize();
  // }
  //
  // public handleAuthentication(): void {
  //   this.auth0.parseHash((err, authResult) => {
  //     // this.router.navigate(['/profile']);
  //     if (authResult && authResult.accessToken && authResult.idToken) {
  //       window.location.hash = '';
  //       this.setSession(authResult);
  //       // this.router.navigate(['/profile']);
  //     } else if (err) {
  //       // this.router.navigate(['/home']);
  //       // console.log(err);
  //       // alert(`Error: ${err.error}. Check the console for further details.`);
  //     }
  //   });
  // }
  //
  // public logout(): void {
  //   localStorage.clear();
  //   // Go back to the home route
  //   this.router.navigate(['/']);
  // }
  //
  // public isAuthenticated(): boolean {
  //   // Check whether the current time is past the access token's expiry time
  //   const expiresAt = JSON.parse(localStorage.getItem('expires_at'));
  //   return new Date().getTime() < expiresAt;
  // }
  //
  // private setSession(authResult): void {
  //   // Set the time that the access token will expire at
  //   const expiresAt = JSON.stringify((authResult.expiresIn * 1000) + new Date().getTime());
  //   localStorage.setItem('access_token', authResult.accessToken);
  //   localStorage.setItem('id_token', authResult.idToken);
  //   localStorage.setItem('expires_at', expiresAt);
  // }
// }
